export const INBOUND = 1
export const OUTBOUND = 2

export const DIRECTION_ALL_TEXT = 'all'
export const DIRECTION_INBOUND_TEXT = 'inbound'
export const DIRECTION_OUTBOUND_TEXT = 'outbound'
